module.exports = __webpack_public_path__ + "img/timer_clock_outlined.f7b68ca4.svg";